<template>
  <div>
    <div
      v-for="i in Math.ceil(fields.length / 3)" :key="i"
      class="row">
      <public-edit-item
        v-for="item in fields.slice((i - 1) * 3, i * 3)" :key="item.uid"
        :itemData="item"
        :answers="completedForm"></public-edit-item>
    </div>
  </div>
</template>

<script>
import PublicEditItem from './PublicEditItem'

export default {
  name: 'PublicEditForm',
  props: {
    fields: {
      type: Array,
      default () {
        return []
      }
    },
    completedForm: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  components: {
    'public-edit-item': PublicEditItem
  },
  methods: {
  }
}
</script>
